import { InvoiceEmail } from "@braidpay/shared"
import { User } from "@/api/users"
import { Customer } from "@/api/customers"
import { z } from "zod"
import { invoiceSchema } from "./invoice.schema"
import Frame from "@/components/frame"

interface PreviewEmailProps {
  invoice: z.input<typeof invoiceSchema>;
  user: User;
  customer?: Customer;
}

export default function PreviewEmail({
  invoice,
  user,
  customer,
}: PreviewEmailProps) {
  return (
    <>
      <div className="p-5 bg-gray-100 rounded-t-xl m-3">
        <div className="text-md font-semibold mb-2">
          New invoice from {user.firstName}
        </div>
        <div className="text-sm text-gray-500">
          <span className="text-black">To:</span>{" "}
          <span className="text-gray-300">{customer && customer.email}</span>
        </div>
      </div>
      <Frame className="w-full flex-grow overflow-scroll">
        <InvoiceEmail
          from={`${user.firstName} ${user.lastName}`}
          to={customer ? `${customer.firstName} ${customer.lastName}` : ""}
          token={invoice.token}
          total={invoice.items.reduce(
            (acc, item) => acc + Number(item.unitValue) * Number(item.quantity),
            0,
          )}
          items={invoice.items.map((item) => ({
            description: item.description,
            quantity: Number(item.quantity),
            unitValue: Number(item.unitValue),
          }))}
          dueDate={invoice.dueDate || new Date()}
          number={1}
          payLink="#"
          invoiceLink="#"
        />
      </Frame>
    </>
  )
}
